import '@xo-union/tk-ui-typography/lib/globals.css';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import textCellStyles from './text-cell.scss';
import styles from './text-cell.scss';

class TextCell extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    title: PropTypes.string,
    className: PropTypes.string,
    styles: PropTypes.string,
    onClick: PropTypes.func,
    query: PropTypes.string,
    type: PropTypes.string,
    disabled: PropTypes.bool,
  };

  getMessageStyle = () => {
    const { disabled, type } = this.props;
    if (disabled) {
      return textCellStyles.disabledInput;
    } else if (type === 'notes') {
      return textCellStyles.notes;
    } else {
      return textCellStyles.message;
    }
  };

  renderValue = () => {
    const { query, value } = this.props;
    const messageStyle = this.getMessageStyle();

    if (!query) return value ? <input disabled className={messageStyle} value={value} /> : '-';
    const matcher = new RegExp(`(${query})`, 'gi');

    const matches = value.split(matcher);
    return matches.map((match, i) => {
      if (match.toLowerCase() === query.toLowerCase()) {
        return (
          <span className={textCellStyles.matchedCharacters} key={`matches${i}`}>
            {match}
          </span>
        );
      }
      return match;
    });
  };

  render() {
    const { title, value, disabled } = this.props;
    const cellTitle = title || value;

    return (
      <div
        className={classnames(textCellStyles.textCell, this.props.className, {
          [textCellStyles.disabledTextCell]: disabled,
        })}
        title={cellTitle}
      >
        <span className={classnames({ [styles.link]: !!this.props.onClick })} onClick={this.props.onClick}>
          {this.renderValue()}
        </span>
      </div>
    );
  }
}

export default TextCell;
